import Vue from "vue";
import Component from "vue-class-component";
import $ from "jquery";
import { ServicesFactoryInstance } from "../../Controls/ServicesFactory";
import { ParametreDto } from "../../../dto/GenApi.iNotPaie.Dto/ParametreDto";
import { RubriqueDto } from "../../../dto/GenApi.iNotPaie.Dto/RubriqueDto";
import { NotificationServiceInstance } from "../../../shared/services/notification.service";

@Component
export default class ModalAjoutUpdateLibelle extends Vue {
	public dataReady = false;
	public dataSaving = false;
    public isUpdate = false;
    public listeLibelles: ParametreDto[] = [];
	public libelle: ParametreDto = {
    	Id: 0,
    	Modifiable: false,
    	EstVisiblePst: false,
    	EstVisibleEtudePst: false,
    	EstArchive: false,
    	CodeCategorie: ""
	};

    public listeRubriques: RubriqueDto[] = [];

    public Init(listeRubriques: any, filterTypeLibelle: any, listeLibelles: ParametreDto[], id?: any): void {
    	this.dataReady = false;
    	this.isUpdate = id != undefined;
        this.listeRubriques = listeRubriques;
        this.listeLibelles = listeLibelles;

    	if (this.isUpdate) {
    		ServicesFactoryInstance.ParametreService.getParametre(id, (data) => {
                this.libelle = data;

    			this.dataReady = true;
    		}, () => {
    			this.dataReady = true;
    		});
        } else {
    		this.libelle = {
    			Id: 0,
    			Modifiable: false,
    			EstVisiblePst: false,
    			EstVisibleEtudePst: false,
    			EstArchive: false,
    			CodeCategorie: filterTypeLibelle
    		};
    		this.dataReady = true;
    	}
        this.$forceUpdate();
	}

	public annuler(): void {
    	$("#modalAjoutUpdateLibelle").modal("hide");
	}

	public getLibelleRubrique(code: string): string {
    	if (code != undefined) {
    		for (const r of this.listeRubriques) {
    			if (code == r.CodeRubrique) {
    				if (r.LibelleRubrique != undefined) {
    					return r.LibelleRubrique;
    				}
    			}
    		}
    	}

    	return "";
	}

	public save(): boolean | void {
    	// Validation
    	const errorMessage: string[] = [];
    	if (this.libelle.Code == undefined || this.libelle.Code === "") {
    		errorMessage.push("Le Code est obligatoire");
        }
    	if (this.libelle.Libelle == undefined || this.libelle.Libelle === "") {
    		errorMessage.push("Le Libelle est obligatoire");
        } else if (this.libelle.Libelle.length > 65) {
            errorMessage.push("Le Libelle est trop long (max 65 caractères)")
        }
    	if (errorMessage.length > 0) {
    		for (let i = 0; i < errorMessage.length; i++) {
    			NotificationServiceInstance.SendFailed(errorMessage[i]);
    		}

    		return false;
        }
    	if (!this.checkCodeRubrique(this.libelle.CodeRubrique1) ||
            !this.checkCodeRubrique(this.libelle.CodeRubrique2) ||
            !this.checkCodeRubrique(this.libelle.CodeRubrique3)) {
    		NotificationServiceInstance.SendFailed("Un code rubrique ne correspond à aucune rubrique valide.");

    		return false;
        }

    	this.dataReady = false;
    	this.dataSaving = true;
    	if (this.isUpdate) {
    		ServicesFactoryInstance.ParametreService.updateParametre(this.libelle, data => {
    			NotificationServiceInstance.SendSuccess("Le libellé a été modifié avec succès.");
    			this.$emit("updateLibelle", data);
    			this.dataReady = true;
    			this.dataSaving = false;
    			this.annuler();
    		}, () => {
    			this.dataReady = true;
    			this.dataSaving = false;
    		});
        } else {
            if (this.listeLibelles.filter(l => l.Code === this.libelle.Code).length > 0) {
                NotificationServiceInstance.SendFailed("Ce code est déjà utilisé dans un libellé de cette catégorie.");

                this.dataReady = true;
                this.dataSaving = false;
                return false;
            }

    		ServicesFactoryInstance.ParametreService.addParametre(this.libelle,
    			data => {
    				NotificationServiceInstance.SendSuccess("Le libellé a été ajouté avec succès.");
    				this.$emit("addLibelle", data);
    				this.dataReady = true;
    				this.dataSaving = false;
    				this.annuler();
    			}, () => {
    				this.dataReady = true;
    				this.dataSaving = false;
    			});
    	}
	}

	public checkCodeRubrique(code: any): boolean {
    	return code == undefined || code == "" || this.listeRubriques.filter(r => r.CodeRubrique == code).length != 0;
	}
}



// WEBPACK FOOTER //
// ./src/components/libelles/modalAjoutUpdateLibelle/modalAjoutUpdateLibelle.ts